import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { apiFetch } from "@/lib/api-fetch";

const AUTH_DISABLED = import.meta.env.VITE_DISABLE_AUTH === "true";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading, token } = useAuth();
  const location = useLocation();
  const [billingStatus, setBillingStatus] = useState<string | null>(null);
  const [billingChecked, setBillingChecked] = useState(false);

  useEffect(() => {
    if (AUTH_DISABLED || !token) {
      setBillingChecked(true);
      return;
    }
    apiFetch("/api/billing/status", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        setBillingStatus(data?.subscription_status || null);
        setBillingChecked(true);
      })
      .catch(() => setBillingChecked(true));
  }, [token]);

  if (AUTH_DISABLED) {
    if (!isAuthenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <>{children}</>;
  }

  if (loading || !billingChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If subscription is expired, only allow billing page
  if (billingStatus === "expired" && !location.pathname.includes("/billing")) {
    return <Navigate to="/app/billing" replace />;
  }

  return <>{children}</>;
}
